import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  MenuItem,
  Select,
  Typography,
  Chip,
  Box,
  InputLabel,
  Autocomplete,
  TextField,
} from "@material-ui/core";
import { getAllUsers, getUsersByRole } from "../../actions";
import jwt from "jsonwebtoken";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function UsersByRole({
  setNewFormState,
  label,
  placehold,
  apiString,
  name,
  formState,
  changeHandler,
  required,
  disabled,
  classes,
  loginid,
}) {
  const [userData, setUserData] = useState([]);
  const [filteredUserData,setFilteredUserData ]= useState([]);
  const [filterloginUser, setFilterLoginUser] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);
  const getUsers = async () => {
    setLoading(true);
    if (apiString === "All") {
      getAllUsers(setUserData, setLoading);
    } else {
      getUsersByRole(apiString, setUserData, setLoading);
    }
  };
  useEffect(() => {
    getUsers();
  }, []);

  useEffect(()=>{
    const selectedUserIds = formState.add_Reviser;
    const newFilteredData = userData?.filter(user => !selectedUserIds?.includes(user?.userId));
    setFilteredUserData(newFilteredData);
  },[formState?.add_Reviser])

  useEffect(()=>{
    setFilteredUserData(userData)
  },[userData])

  return (
    <div>
      <Typography style={{ color: "black" }}>
        <span className={classes.asterisk}>{required ? "*" : ""}</span>
        {label}:
      </Typography>

      <Autocomplete
        sx={{
          "& .MuiInputBase-root": {
            height: "30px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
          },
          "& .MuiInputBase-input": {
            marginTop: "-4px", // Adjust this value to move the text up
            fontSize: 15
          },
        }}
        size="small"
        style={{ width: "100%" }}
        disabled={disabled}
        name={name}
        value={userData.find((user) => user?.userId === formState[name]) || ""}
        onChange={(event, newValue) => {
          setNewFormState((prevState) => ({
            ...prevState,
            [name]: newValue?.userId || "",
          }));
        }}
        // options={userData}
        options={filteredUserData.filter(user => user)} 
        getOptionLabel={(option) =>
          option
            ? apiString === "All"
              ? `${option?.username}`
              : `${option?.userName}`
            : ""
        }
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            // variant="standard"
            size="small"
            required={required}
            placeholder="select a user"
          />
        )}
      />
    </div>
  );
}

export default UsersByRole;
